import { render, staticRenderFns } from "./OverviewContent.vue?vue&type=template&id=710a6dc6&scoped=true&"
import script from "./OverviewContent.vue?vue&type=script&lang=ts&"
export * from "./OverviewContent.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewContent.vue?vue&type=style&index=0&id=710a6dc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a6dc6",
  null
  
)

export default component.exports